export const CRUDABLE_RESOURCES = [
  'event',
  'field',
  'fieldValue',
  'list',
  'note',
  'recruit',
  'task',
  'tourney',
  'tourneyTeam',
  'user',
  'venue'
];


// WEBPACK FOOTER //
// ./src/js/FastRecruit/constants.js